import { Injectable } from '@angular/core';
import { partsModel } from '../models/partInfo';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalconfigService } from '../common/globalConfig.service';
// tslint:disable-next-line: import-blacklist
import { Observable } from 'rxjs';




const BASE_URL = 'assets/api/json/';

@Injectable()
export class PfepService {
  constructor(private http: HttpClient, private config: GlobalconfigService) {
    console.log("global config 5",this.config)

   }

  noubaUploadFile(fileData, currentUser): Observable<any>  {
    const masterDataUploadUrl =
      this.config.baseApiUrlPfep + 'upload/nouba/' + currentUser;
    return this.http.post(masterDataUploadUrl, fileData);
  }
  rackUploadFile(fileData, currentUser): Observable<any>  {
    const masterDataUploadUrl =
      this.config.baseApiUrlPfep + 'upload/rack/' + currentUser;
    return this.http.post(masterDataUploadUrl, fileData);
  }

  getBuildingData(): Observable<any> {
    const masterDataUploadUrl =
      this.config.baseApiUrlPfep + 'buildings';
    return this.http.get(masterDataUploadUrl);
  }
  getRackHistoryData(code): Observable<any> {
    const masterDataUploadUrl =
      this.config.baseApiUrlPfep + 'rack/' + code + '/history';
    return this.http.get(masterDataUploadUrl);
  }
  getNoubaHistoryData(code): Observable<any> {
    const masterDataUploadUrl =
      this.config.baseApiUrlPfep + 'nouba/' + code + '/history';
    return this.http.get(masterDataUploadUrl);
  }

  getNoubaCodes(code): Observable<any> {
    const noubaCodesUrl =
      this.config.baseApiUrlPfep + 'nouba/autocomplete?code=' + code;
    return this.http.get(noubaCodesUrl);
  }
  getRackCodes(code): Observable<any> {
    const rackCodesUrl =
      this.config.baseApiUrlPfep + 'rack/autocomplete?code=' + code;
    return this.http.get(rackCodesUrl);
  }

  updateRackDetails(dataToUpdate): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'rack/update';
  return this.http.put(masterDataUploadUrl, dataToUpdate);
  }
  addRackDetails(dataToAdd): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'rack/add';
  return this.http.post(masterDataUploadUrl, dataToAdd);
  }

  deletRackDetails(rackCode, currentUser): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'rack/delete?user=' + currentUser;
  return this.http.post(masterDataUploadUrl, rackCode);
  }

  updateNoubaDetails(dataToUpdate): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'nouba/update';
  return this.http.put(masterDataUploadUrl, dataToUpdate);
  }

  addNoubaDetails(dataToAdd): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'nouba/add';
  return this.http.post(masterDataUploadUrl, dataToAdd);
  }

  deletNoubaDetails(noubaCode, currentUser): Observable<any> {
    const masterDataUploadUrl =
    this.config.baseApiUrlPfep + 'nouba/delete?user=' + currentUser;
  return this.http.post(masterDataUploadUrl, noubaCode);
  }

  getNoubaData(dataObj): Observable<any> {
    const noubaDataUrl =
      this.config.baseApiUrlPfep + 'nouba/details';
    return this.http.post(noubaDataUrl, dataObj);
  }
  getRackData(dataObj): Observable<any> {
    const rackDataUrl =
      this.config.baseApiUrlPfep + 'rack/details';
    return this.http.post(rackDataUrl, dataObj);
  }

  noubaDataBySearch(searchObj): Observable<any> {
    const dataByBuildingNumUrl = this.config.baseApiUrlPfep + 'nouba/details';
    return this.http.post(dataByBuildingNumUrl, searchObj);
  }
  rackDataBySearch(searchObj): Observable<any> {
    const dataByBuildingNumUrl = this.config.baseApiUrlPfep + 'rack/details';
    return this.http.post(dataByBuildingNumUrl, searchObj);
  }
}
